export default __webpack_public_path__ + "static/media/madworld_logo.2898c382.webp";